// Storage keys for localStorage persistence
export const HIDDEN_STORAGE_KEY = "feedback-widget-hidden";
export const POSITION_STORAGE_KEY = "feedback-widget-position";
export const ATTENTION_DISMISSED_STORAGE_KEY = "feedback-attention-dismissed";

// Bubble sizing and positioning
export const BUBBLE_SIZE = 48;
export const DEFAULT_MARGIN = 16;
export const MOBILE_DEFAULT_BOTTOM = 100; // Higher on mobile to avoid navbar

// Attention timing
export const ATTENTION_INTERVAL = 45000; // 45 seconds between attention grabs
export const ATTENTION_DURATION = 4000; // How long the message stays visible
export const ATTENTION_INITIAL_DELAY = 10000; // 10 seconds before first attention
export const ATTENTION_COOLDOWN_HOURS = 24; // Hours before showing attention again after dismiss
